const headerConfig = {
  logo: {
    text: "Cars Infinite",
    alt: "Cars Infinite",
    path: "/",
  },
  trustBar: {
    enabled: true,
    items: [
      { id: 1, label: "200+ Point Inspection" },
      { id: 2, label: "Warranty Available" },
      { id: 3, label: "Easy EMI & Finance" },
      { id: 4, label: "RC Transfer Support" },
    ],
  },
  sellCta: {
    label: "Sell Car",
    path: "/upload-car",
  },
  navItems: [
    { id: "buy", type: "mega", label: "Buy Car", path: "/cars", menuKey: "brands" },
    { id: "sell", type: "link", label: "Sell Car", path: "/upload-car" },
    { id: "valuation", type: "link", label: "Valuation", path: "/valuation" },
    { id: "compare", type: "link", label: "Compare", path: "/compare" },
    { id: "finance", type: "link", label: "Finance", path: "/finance" },
    { id: "about", type: "link", label: "About Us", path: "/about" },
    { id: "contact", type: "link", label: "Contact", path: "/contact" },
  ],
  search: {
    placeholder: "Search by brand, model, year, or location...",
    urlParam: "q",
  },
  megaMenu: {
    buySubTitle: "Select Category",
    backLabel: "← Back",
  },
  auth: {
    loginLabel: "Login",
    profileLabel: "Profile",
    tokenKey: "cftoken",
  },
};

export default headerConfig;
